export const roles = {
    ADMIN: 1,
    SUPERVISOR: 4,
    MANAGE_FOLIO: 5,
};